import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import BankAccount from './BankAccount';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <BankAccount path="bank_account/*" />
    </Router>
  </Container>
);
